module.exports = __webpack_public_path__ + "img/icon_wuxingbi_module3.36a67f7a.png";